import {
  useLocationName,
  useLocationNames,
} from "components/FormControls/Geo/useLocationNames";

export const LocationName = ({ locationId }: { locationId: string }) => {
  const name = useLocationName(locationId);

  return <span>{name || locationId}</span>;
};

export const LocationNames = ({ locationIds }: { locationIds: string[] }) => {
  const names = useLocationNames(locationIds);

  return (
    <span>{locationIds.map((id) => names[id] || id).join(", ")}</span>
  );
};
